export default __webpack_public_path__ + "static/sitting_in_chairs.30db7ddb2b45db464cab8afcd23699d7.png";